import moment from "moment";

export default {
    name: 'MaintenHistory',
    data() {
        return {
            Start: '',
            End: '',
            Progress: '',
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            this.search();
        },
        async search() {
            var result = await this.$api.searchMaintenHistory(this.Start, this.End, this.Progress);
            var cols = [
                {
                    title: "保養項目",
                    data: "Name",
                    width: 100,
                    render(data, type, row, meta) {
                        return data;
                    }
                },
                {
                    title: "應保養日期",
                    data: "TargetTime",
                    render: window.filters.dateFormat
                }, {
                    title: "開始保養時間",
                    data: "StartTime",
                    render: window.filters.dateTimeFormat
                },
                {
                    title: "完成保養時間",
                    data: "EndTime",
                    render: window.filters.dateTimeFormat
                },
                {
                    title: "完成度",
                    data: "Progress",
                    render(data, type, row, meta) {
                        var state = '';
                        if (data == 100) {
                            state = 'finished';
                        }
                        else {
                            var TargetTime = moment(row["TargetTime"]); 
                            if (moment(TargetTime).add(-3, 'd').isBefore(moment()) && (moment().isBefore(TargetTime) || moment().format("YYYY-MM-DD") == TargetTime.format("YYYY-MM-DD"))) {
                                state = 'in-progress';
                            }
                            else if (moment(TargetTime).add(1, 'd').isBefore(moment()) && moment().isBefore(moment(TargetTime).add(2, 'd'))) {
                                state = 'in-progress';
                            }
                        }
                        return ` <div class="progress">
                        <div class="progress-bar" role="progressbar" aria-valuenow="${data}" aria-valuemin="0" aria-valuemax="100" data-status="${state}" style="width: ${data}%;"></div>
                      </div>
                      <div class="progress-percentage">${data}%</div>`;
                    }
                },
                {
                    title: "操作",
                    data: "Id",
                    render(data, type, row, meta) {
                        return `<a class="btn btn-md btn-default btn-read-more"  onclick="window.model.show(${data})">詳細資訊</a>`;
                    }
                },
            ];
            if (window.mobile) {
                window.$('#modal-search-filter').modal('hide');
            }
            this.createDataTable('#tableData', cols, result, {
                bSort: false, searching: false, createdRow: function (row, data, dataIndex) {
                    var state = 'finished';
                    var TargetTime = moment(data["TargetTime"]);
                    if (moment(TargetTime).add(-3, 'd').isBefore(moment()) && (moment().isBefore(TargetTime) || moment().format("YYYY-MM-DD") == TargetTime.format("YYYY-MM-DD"))) {
                        state = '';
                    }
                    else if (moment(TargetTime).add(1, 'd').isBefore(moment()) && moment().isBefore(moment(TargetTime).add(2, 'd'))) {
                        state = '';
                    }
                    $(row).attr('data-status', state);
                }
            });
        },
        show(id) {
            this.$router.push('/maintenhistory/' + id);
        }
    }
}